import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Brand } from "../../Model/Dto/Brand/Brand";
import { lastValueFrom } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BrandService {

  private readonly apiBrandsUrl: string = 'api/Brand';

  constructor(private http: HttpClient) { }

  getBrands(customerId: string): Promise<Brand[]> {

    const url = `${this.apiBrandsUrl}/GetAll`;
    const params = new HttpParams().append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.get<Brand[]>(url, options));
  }

  updateOrCreateBrand(updateBrand: Brand, customerId: string): Promise<Brand> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("customerId", customerId)
    }

    var result = this.http.post<Brand>("api/Brand/Update", updateBrand, options);
    return lastValueFrom(result);
  }

  public delete(id: string, customerId: string): Promise<Brand> {
    const url = `${this.apiBrandsUrl}/delete`;
    const params = new HttpParams().append('id', id).append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.delete<Brand>(url, options));
  }

}
